import { HttpInterceptorFn } from '@angular/common/http';

export const Interceptor : HttpInterceptorFn = (req, next) => {

  
  // if (req.url.includes('/auth/login') || req.url.includes('/auth/check-session') || req.url.includes('/auth/logout')) {
  //   return next(req);
  // }

  // Add withCredentials for all requests
  const authReq = req.clone({
    withCredentials: true
  });
 
  return next(authReq);
};
